import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';
import type { PermissionEntity } from '../entities/MembershipEntity.js';

interface Deps { membershipRepository: IMembershipRepository; }
export function createListPermissionsForRolesUseCase({ membershipRepository }: Deps) {
  return async function listPermissionsForRoles(roleIds: string[]): Promise<Record<string, PermissionEntity[]>> {
    return membershipRepository.listPermissionsForRoles(roleIds);
  };
}
